export var blockquote = {
    attrs: {
        cite: { default: null },
    },
    content: 'block+',
    group: 'block',
    defining: true,
    parseDOM: [
        {
            tag: 'blockquote',
            // @ts-ignore
            getAttrs: function (element) { return ({
                cite: element.getAttribute('cite'),
            }); },
        },
    ],
    toDOM: function (node) {
        var cite = node.attrs.cite;
        return ['blockquote', { cite: cite }, 0];
    },
};
